import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <rect x='6' y='3' width='3.41772' height='3.41772' rx='1.70886' />
            <rect x='6' y='10.2913' width='3.41772' height='3.41772' rx='1.70886' />
            <rect x='6' y='17.5823' width='3.41772' height='3.41772' rx='1.70886' />
            <rect x='13.5948' y='3' width='3.41772' height='3.41772' rx='1.70886' />
            <rect x='13.5948' y='10.2913' width='3.41772' height='3.41772' rx='1.70886' />
            <rect x='13.5948' y='17.5823' width='3.41772' height='3.41772' rx='1.70886' />
        </SvgIcon>
    );
});
